export const IconsSize = {

    desktop: {
        xs: "16",
        sm: "20",
        md: "24",
        lg: "32",
        xl: "40",
    },

    videowall: {
        // Pixel values calibrated for 3840 px design canvas.
        // These are passed directly as SVG size attributes so must be plain numbers.
        xxs: '16', // canvas 3840px: 0.418 * 38.4 ≈ 16px
        xs:  '24', // canvas 3840px: 0.625 * 38.4 ≈ 24px
        sm:  '26', // canvas 3840px: 0.678 * 38.4 ≈ 26px
        md:  '32', // canvas 3840px: 0.834 * 38.4 ≈ 32px
        lg:  '44', // canvas 3840px: 1.146 * 38.4 ≈ 44px
        xl:  '48', // canvas 3840px: 1.25  * 38.4 ≈ 48px
        xxl: '52', // canvas 3840px: 1.355 * 38.4 ≈ 52px
    }
}

export const IconsSizeWithBg = {
  
    desktop: {
        xxs: '8', //nao definido em ui, poderºa ser acrescentado valor menor no futuro
        xs: "8",
        sm: "12",
        md: "16",
        lg: "24",
        xl: "32",
        xxl: "32" //nao definido em ui, poderºa ser acrescentado valor maior no futuro
    },

    videowall: {
        // Pixel values calibrated for 3840 px design canvas.
        xxs: '12', // 0.318 * 38.4 ≈ 12px
        xs:  '16', // 0.418 * 38.4 ≈ 16px
        sm:  '24', // 0.625 * 38.4 ≈ 24px
        md:  '26', // 0.678 * 38.4 ≈ 26px
        lg:  '32', // 0.834 * 38.4 ≈ 32px
        xl:  '44', // 1.146 * 38.4 ≈ 44px
        xxl: '48', // 1.25  * 38.4 ≈ 48px
    }
}